var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "archive-app" }, [
    _c("div", { staticClass: "archive-app__top-container" }, [
      _c("div", { staticClass: "archive-app__top" }, [
        _c(
          "form",
          {
            staticClass: "archive-app__search",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submitForm.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "archive-app__search-input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchTerm,
                    expression: "searchTerm",
                  },
                ],
                attrs: { placeholder: "Hae" },
                domProps: { value: _vm.searchTerm },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchTerm = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "archive-app__search-input-icon",
                attrs: { type: "submit" },
                domProps: { innerHTML: _vm._s(_vm.headerSearchIcon) },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "archive-app__year" }, [
          _c(
            "label",
            {
              staticClass: "screen-reader-text",
              attrs: { for: "archive-app__change-year" },
            },
            [_vm._v("Valitse vuosi")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.year,
                  expression: "year",
                },
              ],
              attrs: { id: "archive-app__change-year" },
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.year = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.changeYear,
                ],
              },
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v("Valitse vuosi"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.years, function (year) {
                return _c("option", [_vm._v(_vm._s(year))])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "archive-app__year-icon",
            domProps: { innerHTML: _vm._s(_vm.dropdownMenuIcon) },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.currentContentTypes.length
      ? _c(
          "div",
          { staticClass: "archive-app__category-list" },
          [
            _c(
              "div",
              {
                staticClass:
                  "archive-app__category archive-app__category--label",
              },
              [_vm._v("\n            Selaa luokittain\n        ")]
            ),
            _vm._v(" "),
            _vm._l(_vm.currentContentTypes, function (contentType) {
              return _c(
                "div",
                {
                  staticClass: "archive-app__category",
                  class:
                    _vm.currentContentType === contentType.slug
                      ? "archive-app__category--active"
                      : "",
                  on: {
                    click: function ($event) {
                      return _vm.setCurrentContentType(contentType.slug)
                    },
                  },
                },
                [
                  _vm._v("\n            " + _vm._s(contentType.name) + " "),
                  contentType.wwffi_count
                    ? _c("span", [
                        _vm._v(
                          "\n                (" +
                            _vm._s(contentType.wwffi_count) +
                            ")"
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.filteredCategories.length
      ? _c(
          "div",
          { staticClass: "archive-app__category-list" },
          [
            _c(
              "div",
              {
                staticClass:
                  "archive-app__category archive-app__category--label",
              },
              [_vm._v("\n            Selaa aiheittain\n        ")]
            ),
            _vm._v(" "),
            _vm._l(_vm.filteredCategories, function (category) {
              return _c(
                "button",
                {
                  staticClass: "archive-app__category",
                  class: _vm.currentCategory.includes(category.slug)
                    ? "archive-app__category--active"
                    : "",
                  on: {
                    click: function ($event) {
                      return _vm.setCurrentCategory(category.slug)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            #" + _vm._s(category.name) + "\n        "
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _vm.currentCategories.length > 10 && !_vm.showAll
              ? _c(
                  "button",
                  {
                    staticClass:
                      "archive-app__category archive-app__category--button",
                    on: {
                      click: function ($event) {
                        _vm.showAll = true
                      },
                    },
                  },
                  [_vm._v("\n            Näytä enemmän\n        ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCategories.length > 10 && _vm.showAll
              ? _c(
                  "button",
                  {
                    staticClass:
                      "archive-app__category archive-app__category--button",
                    on: {
                      click: function ($event) {
                        _vm.showAll = false
                      },
                    },
                  },
                  [_vm._v("\n            Näytä vähemmän\n        ")]
                )
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.loading && _vm.results.length === 0
      ? _c(
          "div",
          { staticClass: "archive-app__loading-spinner" },
          [_c("LoadingSpinner")],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "archive-app__results" },
      _vm._l(_vm.results, function (result) {
        return _c("div", [
          _c("div", { staticClass: "archive-app__result" }, [
            _c("div", { staticClass: "row" }, [
              result.image
                ? _c("div", { staticClass: "col-lg-4 col-md-5" }, [
                    result.image
                      ? _c(
                          "a",
                          {
                            staticClass: "archive-app__result-image",
                            attrs: { target: "_blank", href: result.url },
                          },
                          [
                            _c("ResponsiveImage", {
                              attrs: { image: result.image },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: result.image
                    ? "col-lg-8 col-md-7"
                    : "col-lg-8 offset-lg-4 col-md-7 offset-md-5",
                },
                [
                  result.content_type
                    ? _c("div", { staticClass: "archive-app__result-meta" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(result.content_type) +
                            " | " +
                            _vm._s(result.date) +
                            "\n                        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !result.content_type
                    ? _c("div", { staticClass: "archive-app__result-meta" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(result.date) +
                            "\n                        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "archive-app__result-title",
                      attrs: { target: "_blank", href: result.url },
                    },
                    [_c("h2", {}, [_vm._v(_vm._s(result.title))])]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "archive-app__result-description",
                    domProps: { innerHTML: _vm._s(result.description) },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "archive-app__result-bottom" },
                    [
                      _vm._l(result.categories, function (category) {
                        return _c("div", [
                          _c(
                            "button",
                            {
                              staticClass: "archive-app__result-category",
                              on: {
                                click: function ($event) {
                                  return _vm.setCurrentCategory(category.slug)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(category.name) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ])
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "archive-app__result-button",
                            attrs: { target: "_blank", href: result.url },
                          },
                          [_vm._v("Lue lisää")]
                        ),
                      ]),
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.results.length &&
    (_vm.total > _vm.page * _vm.postsPerPage || _vm.loading)
      ? _c("div", [
          _c("div", { staticClass: "archive-app__load-more-container" }, [
            _c(
              "button",
              {
                staticClass: "archive-app__load-more",
                attrs: { disabled: _vm.loading },
                on: { click: _vm.loadMore },
              },
              [_vm._v("\n                Lataa lisää\n            ")]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.error && !_vm.loading
      ? _c(
          "div",
          { staticClass: "archive-app__error" },
          [_c("ErrorMessage", { attrs: { message: _vm.errorMessage } })],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }